import { authService } from './auth.service';
import { calcAssignableRoles } from './authHelpers';
import { useStoreGuid } from '@/lib/hooks';
import { useAppSelector } from '@/redux';
import { ScopeParameters } from '@whiz-cart/ui-shared/auth/authTypes';
import { calcActiveRoles } from '@whiz-cart/ui-shared/auth/calcActiveRoles';
import { calcHasClaim } from '@whiz-cart/ui-shared/auth/calcHasClaim';
import { useCallback, useMemo } from 'react';

export function useAuth() {
    const loginState = authService.loginState.useState();
    const { stores, isLoaded: areStoresLoaded } = useAppSelector((state) => state.stores);
    const { storeGuid } = useStoreGuid();
    const [roleHierarchy = {}] = authService.roleHierarchy.useAction(undefined);
    const isAuthLoading = !areStoresLoaded || !loginState.claimMapping;

    const getActiveRoles = useMemo(() => calcActiveRoles(loginState, stores, storeGuid), [loginState, stores, storeGuid]);

    const hasRole = useCallback(
        (roles: string | string[], ...scope: ScopeParameters) => {
            const activeRoles = getActiveRoles(...scope);
            if (!Array.isArray(roles)) {
                roles = [roles];
            }

            return activeRoles.has('admin') || roles.some((role) => activeRoles.has(role));
        },
        [getActiveRoles],
    );

    const hasClaim = useMemo(() => calcHasClaim(loginState, stores, storeGuid), [loginState, stores, storeGuid]);

    const getAssignableRoles = useMemo(() => calcAssignableRoles(roleHierarchy), [roleHierarchy]);

    return { ...loginState, getActiveRoles, hasRole, hasClaim, getAssignableRoles, isAuthLoading };
}
